import { TableHoverActions, useModal, withModalConditionalRender } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useRegisterBillPayment } from '@features/bills/hooks/useRegisterBillPayment'
import { Bill } from '@features/bills/types/bill'

import { useSegment } from '../../../../../../../../../hooks'
import { BillReconciliationModal as BillReconciliationModalComponent } from '../../../../../../../elements/BillReconciliationModal'
import { BillsTableStaticActionType } from '../../../../../../../enums/billsTableStaticActionType'

const BillReconciliationModal = withModalConditionalRender(BillReconciliationModalComponent)

export const getBillReconciliationModalId = (id: string) => `${id}-bill-reconciliation-hover-action`

interface BillsTableStaticActionsProps {
  bill: Bill
  billId: string
}

export const BillsTableHoverActions = ({ billId, bill }: BillsTableStaticActionsProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const billReconciliationModalId = getBillReconciliationModalId(billId)
  const { open: openBillReconciliationModal } = useModal(billReconciliationModalId)

  const { handleRegisterPayment } = useRegisterBillPayment({
    bill,
    openReconciliationModal: openBillReconciliationModal,
  })

  const handleRegisterPaymentActionClick = useCallback(() => {
    track('xxx - bookkeeping - QuickAction Clicked', {
      list: 'Bills',
      button: BillsTableStaticActionType.RegisterPayment,
    })
    handleRegisterPayment()
  }, [handleRegisterPayment, track])

  return (
    <TableHoverActions>
      <TableHoverActions.Item
        icon="handCoins"
        label={t('bills.table.static_actions.register_payment')}
        onClick={handleRegisterPaymentActionClick}
      />

      {bill && <BillReconciliationModal subject={bill} id={billReconciliationModalId} />}
    </TableHoverActions>
  )
}
